import React from 'react'
import PropTypes from 'prop-types'

const directions = ['asc', 'desc']

const SortButton = ({ sortDir, isActive, ...props }) => (
	<button type="button" className={isActive ? 'active' : ''} {...props}>{sortDir}</button>
)

const SortControls = ({ sortKey, currentSortBy, currentSortDir, onChangeSort }) => {
	return (
		<div className="SortControls">
			{	directions.map(sortDir =>
				<SortButton
					key={`${sortKey}-${sortDir}`} 
					sortDir={sortDir}
					isActive={currentSortBy === sortKey && sortDir === currentSortDir}
					onClick={() => onChangeSort(sortKey, sortDir)}
				/>
			)}
		</div>
	)
}

SortControls.propTypes = {
	sortKey: PropTypes.string.isRequired,
	currentSortDir: PropTypes.oneOf(['asc', 'desc']),
	currentSortBy: PropTypes.string,
}

export default SortControls


// WEBPACK FOOTER //
// ./src/components/DataTable/components/SortControls.jsx